import React from "react";
import { Link, PageLayout, useQuery, DynamicTable, } from "@atlassiansox/microscopekit";
import panelInstallationsQuery from "./panel-installations.query.graphql";
import ShortcutIcon from "@atlaskit/icon/glyph/shortcut";
export var PanelInstallations = function (props) {
    var _a, _b;
    var _c = useQuery(panelInstallationsQuery, {
        variables: {
            query: "type: services AND platform:micros AND microscopePanels:" + props.id,
            first: 100,
        },
    }), data = _c.data, loading = _c.loading, error = _c.error;
    if (error) {
        return (React.createElement(PageLayout, { title: "Panel Installations" },
            React.createElement("p", null, "Sorry we couldn't load the list of services. Try refreshing the page.")));
    }
    var rows = ((_b = (_a = data === null || data === void 0 ? void 0 : data.search) === null || _a === void 0 ? void 0 : _a.edges) !== null && _b !== void 0 ? _b : [])
        .filter(function (e) { return e !== null; })
        .map(function (e) {
        var _a;
        var service = e.node;
        return {
            key: service.id,
            cells: [
                {
                    content: (React.createElement(Link, { to: "/services/" + encodeURIComponent(service.id), title: service.id })),
                    width: 2,
                },
                {
                    content: (_a = service.metadata.description) !== null && _a !== void 0 ? _a : "",
                    width: 7,
                },
                { key: "owner", content: service.metadata.owner.id, width: 1 },
                {
                    content: (React.createElement(Link, { to: "/services/" + encodeURIComponent(service.id) + "/panels/" + encodeURIComponent(props.id) },
                        React.createElement(ShortcutIcon, { size: "small", label: "shortcut" }))),
                    width: 1,
                },
            ],
        };
    });
    var count = rows.length ? "(" + rows.length + ")" : "";
    return (React.createElement(PageLayout, { title: "Panel Installations " + count },
        React.createElement(DynamicTable, { head: {
                cells: [
                    { key: "id", content: "Service Name", width: 2 },
                    { key: "description", content: "Description", width: 7 },
                    { key: "owner", content: "Owner", width: 1 },
                    { key: "link", content: "", width: 1 },
                ],
            }, rows: rows, isLoading: loading, emptyView: React.createElement("p", null, "This panel is not installed on any service") })));
};
